import { useNavigate } from "react-router-dom";
import { Button, Form, FormGroup, Input, InputGroup, InputGroupText, Label } from "reactstrap";
import { Lock, Mail } from "react-feather";
import { toast } from "react-toastify";
// import { Image } from "../../../AbstractElements";
import { EmailAddress, Password, RememberPassword, SignIn } from "../../../Constant";
import { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { clearAuthState, setFormData, setRemember } from "../../../Services/Features/Auth/authSlice";
import { login } from "../../../Services/Features/Auth/Utils/authUtils";
import img from '../../../assets/logo-qeza-care-color-swapped.jpg';
import { GetAdminRole } from 'Component/Common/GetAdminRole';

export default function LoginForm() {
  const history = useNavigate();
  const email = useSelector((state) => state.auth.form.email);
  const password = useSelector((state) => state.auth.form.password);
  const [isPasswordVisible,setisPasswordVisible] = useState(false);
  const dispatch = useDispatch();
  const auth = useSelector((state) => state.auth);
  const form = useSelector((state) => state.auth.form);
  const remember = useSelector((state) => state.auth.remember);
  const localRemember = JSON.parse(localStorage.getItem("REMEMBER_QEZA"));

  useEffect(() => {
    if (localRemember) {
      setFormData({ ...form, email: localRemember.email });
      dispatch(setFormData({ ...form, email: localRemember.email }));
      dispatch(setRemember(true));
    }
  }, []);

  const toggle = () =>{ setisPasswordVisible(!isPasswordVisible)};
  // var images = require.context("../../../assets/images", true);
  // const dynamicImage = (image) => {
  //   return images(`./${image}`);
  // };

  const validateForm = (form) => {
    const errors = {};

    if (!form.email) {
      errors.email = "Email tidak boleh kosong!";
    } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(form.email)) {
      errors.email = "Email tidak valid!";
    }

    if (!form.password) {
      errors.password = "Password tidak boleh kosong!";
    }

    return errors;
  };

  const showErrors = (errors) => {
    Object.values(errors).forEach((error) => {
      toast.error(error, { position: toast.POSITION.TOP_RIGHT });
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    const errors = validateForm(form);

    if (Object.keys(errors).length > 0) {
      showErrors(errors);
      return;
    }

    dispatch(login(form));
  };


  const handleRememberChange = (e) => {
    dispatch(setRemember(e.target.checked));
  };
  const user = JSON.parse(localStorage.getItem('USER'));
  const role = GetAdminRole(user);

  const defaultPath = role === 'admin' || role === 'cs' ? '/orders' : '/dashboard';

  useEffect(() => {
    if (auth.success && auth.redirect) {
      toast.success("Login berhasil!", {
        position: toast.POSITION.TOP_RIGHT,
        autoClose: 2500,
      });
      history(`${process.env.PUBLIC_URL}${defaultPath}`);
    } else if (auth.error) {
      toast.error(auth.error, {
        position: toast.POSITION.TOP_RIGHT,
      });
    }

    return () => {
      dispatch(clearAuthState());
    };
  }, [auth.success, auth.redirect, auth.error, dispatch]);

  const handleChanges = (e) => {
    dispatch(setFormData({ ...form, [e.target.name]: e.target.value }));
  };

  return (
    <div>
      <div className='login-card1'>
        <div style={{
          position: 'absolute',
          top: '100px',
          left: '50%',
          transform: 'translateX(-50%)',
          zIndex: '0',
        }}>
          <img
            src={img}
            alt="Logo"
            style={{
              width: '80px',
              height: '80px',
              borderRadius: '50%',
              objectFit: 'cover'
            }}
          />
        </div>
        <Form className='theme-form login-form' onSubmit={handleSubmit} style={{ zIndex: '1' }}>
          <div className='login-header text-center'>
            <h4>Dashboard Superadmin</h4>
            <h6>Welcome back team! Log in to your account.</h6>
          </div>

          <FormGroup>
            <Label>{EmailAddress}</Label>
            <InputGroup>
              <InputGroupText>
                <Mail />
              </InputGroupText>
              <Input type='email' name='email' required placeholder='example@gmail.com' defaultValue={email} onChange={handleChanges} />
            </InputGroup>
          </FormGroup>
          <FormGroup>
            <Label>{Password}</Label>
            <InputGroup>
              <InputGroupText>
                <Lock />
              </InputGroupText>
              <Input type={isPasswordVisible ? "text" : "password"} name='password' required placeholder='*********' defaultValue={password} onChange={handleChanges} />
              <div className='show-hide' onClick={toggle}>
              <span className={!isPasswordVisible ? "show" : ""}></span>
            </div>
            </InputGroup>
          </FormGroup>

          <FormGroup className='login-btn'>
            <div className='checkbox'>
              <Input id='checkbox1' type='checkbox' checked={remember} onChange={handleRememberChange} />
              <Label className='text-muted' for='checkbox1'>
                {RememberPassword}
              </Label>
            </div>
            {/* <Link href='/pages/authentication/forgetpwd' className='link'>
              {ForgotPassword}?
            </Link> */}
          </FormGroup>
          <FormGroup>
            {/* <Link to={"/"}> */}
              <Button className='btn-block' color='primary' type='submit' onClick={handleSubmit}>
                {SignIn}
              </Button>
            {/* </Link> */}
          </FormGroup>
        </Form>
      </div>
    </div>
  );
}
